module.exports = __webpack_public_path__ + "img/组 2544.c0cb83ca.png";